import DateFormatterUtils from '../utils/date-formatter-utils';

export default function (value) {
  if (!value) {
    return '';
  }
  return DateFormatterUtils.formatTimeHourMinute(value);
}
